import { Router } from '@angular/router';
import { TipoDeBem } from './../../../_core/models/tipo-de-bem';
import { TipoDeBemService } from './../../../_core/services/tipo-de-bem.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Page } from 'src/app/_core/models/page';
import { PageService } from 'src/app/_core/services/page.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoDeBensModalComponent } from '../tipo-de-bens-modal/tipo-de-bens-modal.component';


@Component({
  selector: 'app-tipo-de-bens',
  templateUrl: './tipo-de-bens.component.html',
  styleUrls: ['./tipo-de-bens.component.scss']
})
export class TipoDeBensComponent implements OnInit {
form !: FormGroup;
tiposDeBem !: TipoDeBem;
tipoDeBem!:TipoDeBem[];
myDate = new Date();
pagina = 1;
total = 10;
page!: Page;
ativo = true;
pesquisa = '';
loading = true;

  constructor(
    private fb:FormBuilder,
    private router:Router,
    private tipoDeBemService:TipoDeBemService,
    private pageService:PageService,
    private modalService:NgbModal) { }

  ngOnInit(){
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.listarTipoDeBensAll();
    
  }
   
  setPage(page:number){
    this.loading = true;
    this.page.currentPage = page;
    this.tipoDeBemService.listarPage(this.page)
    .subscribe(
      data => {
        //console.log/data);
        this.page = data;
        this.page = this.pageService.getPager(this.page);
        this.loading = false;
      },
      err => {
        this.loading = false;
      })
  }

  listarTipoDeBensAll() {
    this.tipoDeBemService.listarTipoDeBensAll()
    .subscribe(
      data => {
        this.tipoDeBem = data;
      }
    )
  }

  paginaAtual(pagina:any) {
    return this.page.currentPage === pagina;
  }

  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }

  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }

  delete(nR_BPM_TIPO_BEM_PATRIMONIAL:number) {
    
    Swal.fire({
      title: 'Deseja deletar esse tipo de bem?',
      confirmButtonText: 'Deletar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.tipoDeBemService.delete(nR_BPM_TIPO_BEM_PATRIMONIAL).
        subscribe(
          data => {
            const msg:string = 'O tipo de bem foi deletado com sucesso!'
            Swal.fire(
              'Sucesso!',
              msg,
              'success'
            ).then(() => {
              this.atualizar();
            });
          },
          err => {
            ////console.log/JSON.stringify(err))
            let msg:string = 'Erro ao deletar,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error;
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
            ////console.log/JSON.stringify(err))
          }
        )
      }
    })
  }

  abreEdicao(nR_BPM_TIPO_BEM_PATRIMONIAL:any): void {
    const modalRef = this.modalService.open(TipoDeBensModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_TIPO_BEM_PATRIMONIAL = nR_BPM_TIPO_BEM_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }

  /*cadastrarTipoDeBem(){
    const tipoDeBem:TipoDeBem = this.form.value;
    Swal.fire({
      title:'Deseja cadastrar esse tipo de bem?',
      confirmButtonText:'Cadastrar',
      showCancelButton:true,
      cancelButtonText:'Cancelar',
      icon:'info',
    }).then((result) => {
      if (result.isConfirmed){
        this.tipoDeBemService.insert(tipoDeBem)
        .subscribe(
          (data) => {
            //console.log/'Deu certo' + data);
            //console.log/JSON.stringify(data))
            const msg:string = 'Cadastrado com sucesso!';
          Swal.fire('Sucesso!',msg,'success').then(() => {
            this.loading = false;
          })
          },
        err => {
          //console.log/'Deu erro');
          //console.log/JSON.stringify(err))
          let msg:string = 'Erro ao cadastrar,tente novamente mais tarde!'
          if(err.status == 401){
            return msg = err.error.errors.join('  ');
          }
          Swal.fire('Erro',msg,'error');
        }

    )
      }
    })
    

  } */
}
